export const hasNonAlphanumeric = (input?: string): boolean => {
  if (typeof input !== 'string') return false;

  return Boolean(input?.match(/[^a-zA-Z0-9-]/g));
};

export const removeNonAlphanumeric = (input: string): string => {
  return input.replace(/[^a-zA-Z0-9-]/g, '');
};
